import CtaIcon from '../ui/CtaIcon';
import React, { type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import PageShell from '../ui/PageShell';
import type { PassportFeatureFlags } from '../../services/api/passport';
import { PassportSubnav, type PassportNavId } from './PassportSubnav';

type Props = {
  active: PassportNavId;
  flags?: PassportFeatureFlags | null;
  year?: number;
  /** Hub uses Home; subsections usually back to Passport overview. */
  back?: { label: string; to: string };
  width?: 'narrow' | 'md' | 'wide' | 'full';
  children: ReactNode;
  /** Optional title block below subnav (subsection pages). */
  title?: ReactNode;
};

/**
 * Shared Passport page chrome: safe bottom padding for native Scan FAB,
 * consistent back + section nav across Overview / Recap / Collections / Hunts / Privacy.
 */
export const PassportChrome: React.FC<Props> = ({
  active,
  flags,
  year,
  back = { label: 'Passport', to: '/passport' },
  width = 'wide',
  children,
  title,
}) => {
  return (
    <PageShell width={width} contentClassName="!py-6 sm:!py-8 !pb-28">
      <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <Link
          to={back.to}
          className="text-sm text-zinc-400 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-400/60 w-fit"
        >
          <CtaIcon direction="back" compact /> {back.label}
        </Link>
        <PassportSubnav active={active} flags={flags} year={year} />
      </div>
      {title ? <div className="mb-6">{title}</div> : null}
      {children}
    </PageShell>
  );
};

export default PassportChrome;
